import React, { useContext, useState, useEffect } from "react";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
// import {  Button, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import { IconButton } from "@mui/material";
import { Groups, SaveAlt } from "@mui/icons-material";

import CallIcon from "@material-ui/icons/Call";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import FilterListIcon from "@material-ui/icons/FilterList";
import ClearIcon from "@material-ui/icons/Clear";
import SendIcon from "@material-ui/icons/Send";
import MessageIcon from "@material-ui/icons/Message";
import AccessAlarmIcon from "@material-ui/icons/AccessAlarm";
import TimerIcon from "@material-ui/icons/Timer";
import * as XLSX from "xlsx";
import CheckCircleOutlineIcon from "@material-ui/icons/RecordVoiceOver";
import ErrorOutlineIcon from "@material-ui/icons/RecordVoiceOver";

import { grey, blue } from "@material-ui/core/colors";
import { toast } from "react-toastify";

import MainContainer from "../../components/MainContainer";
import TabPanel from "../../components/TabPanel";
import TableAttendantsStatus from "../../components/Dashboard/TableAttendantsStatus";
import { isArray } from "lodash";

import { AuthContext } from "../../context/Auth/AuthContext";

import useDashboard from "../../hooks/useDashboard";
import useContacts from "../../hooks/useContacts";
import useMessages from "../../hooks/useMessages";
import { ChatsUser } from "./ChartsUser";

import Filters from "./Filters";
import { isEmpty } from "lodash";
import moment from "moment";
import { ChartsDate } from "./ChartsDate";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  SvgIcon,
  Tab,
  Tabs,
  LinearProgress,
  Box,
} from "@mui/material";
import { i18n } from "../../translate/i18n";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import ForbiddenPage from "../../components/ForbiddenPage";
import { createGradient } from "../../utils/themeColors";
import { ArrowDownward, ArrowUpward } from "@material-ui/icons";
import WarningIcon from "@material-ui/icons/Warning";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import LaptopIcon from "@material-ui/icons/Laptop";
import ScheduleIcon from "@material-ui/icons/Schedule";
import RefreshIcon from "@material-ui/icons/Refresh";
import { QueueFilter } from "../../components/QueueFilter";
import { UsersFilter } from "../../components/UsersFilter";
import { ConnectionsFilter } from "../../components/ConnectionsFilter";
import { WhatsappsFilter } from "../../components/WhatsappsFilter";
import { Can } from "../../components/Can";
import AttendanceHeatmap from "./AttendanceHeatmap";
import { getCompanyToday, getCompanyDateRange, resolveCompanyTimezone } from "../../utils/companyTimezone";


const useStyles = makeStyles((theme) => ({
  overline: {
    fontSize: "0.9rem",
    fontWeight: 700,
    color: theme.palette.text.secondary,
    letterSpacing: "0.5px",
    lineHeight: 2.5,
    textTransform: "uppercase",
    fontFamily: "'Plus Jakarta Sans', sans-serif'",
  },
  h4: {
    fontFamily: "'Plus Jakarta Sans', sans-serif'",
    fontWeight: 500,
    fontSize: "2rem",
    lineHeight: 1,
    color: theme.palette.text.primary,
  },
  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },
    "&:hover": {
      backgroundColor: "rgba(6, 81, 131, 0.3)",
    },
    "&$selected": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },
  tabIndicator: {
    borderWidth: "2px",
    borderStyle: "solid",
    height: 6,
    bottom: 0,
    color:
      theme.palette.mode === "light"
        ? theme.palette.primary.main
        : theme.palette.primary.contrastText,
  },
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  dashboardPageWrapper: {
    padding: "10px",
    boxSizing: "border-box",
    width: "100%",
  },
  nps: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.padding,
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 240,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  cardAvatar: {
    fontSize: "55px",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    // Suporte a gradiente de texto quando ativado
    ...(theme.palette?.gradient ? {
      background: createGradient(theme.palette.primary.main, theme.palette.secondary?.main),
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
    } : {
      color: theme.palette.primary.main,
    }),
  },
  cardSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  iframeDashboard: {
    width: "100%",
    height: "calc(100vh - 64px)",
    border: "none",
  },
  customFixedHeightPaperLg: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
  },
  sectionTitle: {
    fontSize: "1.5rem",
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    // Suporte a gradiente de texto quando ativado
    ...(theme.palette?.gradient ? {
      background: createGradient(theme.palette.primary.main, theme.palette.secondary?.main),
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
    } : {
      color: theme.palette.primary.main,
    }),
  },
  mainPaper: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    ...theme.scrollbarStyles,
    backgroundColor: "transparent !important",
    borderRadius: "10px",
  },
  paper: {
    padding: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
  },
  barContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  progressBar: {
    flex: 1,
    marginRight: theme.spacing(1),
    borderRadius: 5,
    height: 10,
  },
  progressLabel: {
    minWidth: 50,
    textAlign: "right",
    fontWeight: 500,
    color: theme.palette.mode === "light" ? theme.palette.text.secondary : theme.palette.text.primary,
  },
  infoCard: {
    padding: theme.spacing(2),
    textAlign: "center",
    borderRadius: 12,
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(2),
  },
  infoIcon: {
    fontSize: "2rem",
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  headerTitle: {
    fontSize: "1.5rem",
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
    paddingLeft: 0,
  },
  modernSectionTitle: {
    fontSize: "1.5rem",
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(4),
    paddingLeft: 0,
  },
  modernHeader: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    marginLeft: 0,
    marginRight: 0,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    boxShadow: theme.shadows[2],
    gap: theme.spacing(2),
  },
  headerFilters: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: theme.spacing(2.5),
    alignItems: "flex-start",
    "@media (max-width: 960px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media (max-width: 600px)": {
      gridTemplateColumns: "1fr",
    },
  },
  headerActions: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(1),
  },
  filterWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.75),
  },
  filterLabel: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    fontWeight: 500,
    marginBottom: theme.spacing(0.25),
  },
  modernMetricCard: {
    padding: theme.spacing(2.5),
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "relative",
    overflow: "hidden",
    borderBottom: `4px solid`,
    transition: "transform 0.2s, box-shadow 0.2s",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: theme.shadows[6],
    },
  },
  metricCardIcon: {
    position: "absolute",
    top: theme.spacing(1.5),
    right: theme.spacing(1.5),
    fontSize: "2.5rem",
    opacity: 0.2,
  },
  metricCardValue: {
    fontSize: "2.25rem",
    fontWeight: 700,
    marginBottom: theme.spacing(0.5),
    color: theme.palette.text.primary,
  },
  metricCardLabel: {
    fontSize: "0.875rem",
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  modernNpsCard: {
    padding: theme.spacing(2),
    borderRadius: 10,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[2],
  },
  modernProgressContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  modernProgressLabel: {
    minWidth: 100,
    fontSize: "0.875rem",
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  modernProgress: {
    flex: 1,
    height: 10,
    borderRadius: 5,
  },
  modernProgressValue: {
    minWidth: 45,
    textAlign: "right",
    fontSize: "0.875rem",
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  modernAttendanceCard: {
    padding: theme.spacing(2),
    borderRadius: 10,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[2],
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    height: "100%",
    transition: "transform 0.2s, box-shadow 0.2s",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: theme.shadows[4],
    },
  },
  modernChartCard: {
    padding: theme.spacing(3),
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    height: "100%",
  },
}));

const Dashboard = () => {
  const theme = useTheme();
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const companyTimezone = resolveCompanyTimezone(user?.company?.timezone || localStorage.getItem("companyTimezone"));
  const defaultDates = getCompanyDateRange(companyTimezone, "last30days");

  const [counters, setCounters] = useState({});
  const [attendants, setAttendants] = useState([]);
  const [filterType, setFilterType] = useState(1);
  const [period, setPeriod] = useState(30);
  const [dateFrom, setDateFrom] = useState(
    moment().tz(companyTimezone).startOf("month").format("YYYY-MM-DD")
  );
  const [dateTo, setDateTo] = useState(getCompanyToday(companyTimezone));
  const [loading, setLoading] = useState(false);
  const { find, getAttendanceHeatmap } = useDashboard();

  //FILTROS NPS
  const [tab, setTab] = useState("Indicadores");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedQueues, setSelectedQueues] = useState([]);

  const [showFilter, setShowFilter] = useState(false);
  const [dateStartTicket, setDateStartTicket] = useState(
    defaultDates.startDate
  );
  const [dateEndTicket, setDateEndTicket] = useState(defaultDates.endDate);
  const [queueTicket, setQueueTicket] = useState(false);
  const [fetchDataFilter, setFetchDataFilter] = useState(false);
  const [selectedQueuesFilter, setSelectedQueuesFilter] = useState([]);
  const [selectedUsersFilter, setSelectedUsersFilter] = useState([]);
  const [selectedConnectionsFilter, setSelectedConnectionsFilter] = useState([]);
  const [selectedChannelsFilter, setSelectedChannelsFilter] = useState([]);
  const [heatmapData, setHeatmapData] = useState([]);
  const [heatmapDetails, setHeatmapDetails] = useState([]);
  const [heatmapMaxCount, setHeatmapMaxCount] = useState(0);
  const [heatmapLoading, setHeatmapLoading] = useState(false);

  const exportarGridParaExcel = () => {
    const ws = XLSX.utils.table_to_sheet(
      document.getElementById("grid-attendants")
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "RelatorioDeAtendentes");
    XLSX.writeFile(wb, "relatorio-de-atendentes.xlsx");
  };

  var userQueueIds = [];

  if (user.queues && user.queues.length > 0) {
    userQueueIds = user.queues.map((q) => q.id);
  }

  useEffect(() => {
    let isMounted = true;
    
    async function firstLoad() {
      if (isMounted) {
        console.log('Executando firstLoad...');
        await fetchData();
      }
    }
    
    const timeoutId = setTimeout(() => {
      firstLoad();
    }, 500);
    
    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDataFilter, dateStartTicket, dateEndTicket, period]);

  async function fetchData() {
    setLoading(true);
    setHeatmapLoading(true);
    console.log('Iniciando fetchData...');
  
    let params = {};
  
    // Construir parâmetros de filtro
    if (period > 0) {
      params = {
        days: period,
      };
      console.log('Usando filtro por dias:', period);
    } else {
      // Se não há período específico, usar as datas
      if (!isEmpty(dateStartTicket) && moment(dateStartTicket).isValid()) {
        params = {
          ...params,
          date_from: moment(dateStartTicket).format("YYYY-MM-DD"),
        };
        console.log('Data de início:', dateStartTicket);
      }
  
      if (!isEmpty(dateEndTicket) && moment(dateEndTicket).isValid()) {
        params = {
          ...params,
          date_to: moment(dateEndTicket).format("YYYY-MM-DD"),
        };
        console.log('Data de fim:', dateEndTicket);
      }
    }
  
    // Se nenhum parâmetro foi definido, usar período padrão de 30 dias
    if (Object.keys(params).length === 0) {
      console.log('Nenhum filtro definido, usando 30 dias como padrão');
      params = { days: 30 };
    }
  
    console.log('Parâmetros finais para busca:', params);

    const heatmapParams = {
      days: period ? period : undefined,
      date_from: !period ? dateStartTicket : undefined,
      date_to: !period ? dateEndTicket : undefined,
      queueIds: JSON.stringify(selectedQueuesFilter.map(item => item.id)),
      userIds: JSON.stringify(selectedUsersFilter.map(item => item.id)),
      whatsappIds: JSON.stringify(selectedChannelsFilter.map(item => item.id))
    };
  
    try {
      const [data, heatmap] = await Promise.all([
        find(params),
        user.profile === "admin"
          ? getAttendanceHeatmap(heatmapParams)
          : Promise.resolve({ summary: [], details: [], maxCount: 0, totalsByDay: [], totalsByHour: [] })
      ]);
      console.log('Dados recebidos no componente:', data);
  
      // Garantir que counters sempre tenha valores válidos
      const safeCounters = data.counters || {};
      
      // Verificar especificamente o campo tickets
      console.log('Campo tickets recebido:', safeCounters.tickets);
      
      setCounters(safeCounters);
      
      if (isArray(data.attendants)) {
        setAttendants(data.attendants);
      } else {
        console.warn('Attendants não é um array:', data.attendants);
        setAttendants([]);
      }
  
      console.log('Estado atualizado - Counters:', safeCounters);
      console.log('Estado atualizado - Attendants:', data.attendants);
      
      // Log específico para verificar se o campo tickets está presente
      console.log('Valor de tickets no estado:', safeCounters.tickets);
      setHeatmapData(Array.isArray(heatmap.summary) ? heatmap.summary : []);
      setHeatmapDetails(Array.isArray(heatmap.details) ? heatmap.details : []);
      setHeatmapMaxCount(heatmap.maxCount || 0);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
      toast.error(i18n.t("dashboard.toasts.loadError"));
      
      // Definir valores padrão em caso de erro
      setCounters({
        avgSupportTime: 0,
        avgWaitTime: 0,
        supportFinished: 0,
        supportHappening: 0,
        supportPending: 0,
        supportGroups: 0,
        leads: 0,
        activeTickets: 0,
        passiveTickets: 0,
        tickets: 0,
        ticketsWithoutQueue: 0,
        ticketsWithoutQueueGroups: 0,
        ticketsWithoutQueuePrivate: 0,
        ticketsWithoutUser: 0,
        ticketsWithoutUserGroups: 0,
        ticketsWithoutUserPrivate: 0,
        waitRating: 0,
        withoutRating: 0,
        withRating: 0,
        percRating: 0,
        npsPromotersPerc: 0,
        npsPassivePerc: 0,
        npsDetractorsPerc: 0,
        npsScore: 0
      });
      setAttendants([]);
      setHeatmapData([]);
      setHeatmapDetails([]);
      setHeatmapMaxCount(0);
    } finally {
      setLoading(false);
      setHeatmapLoading(false);
    }
  }

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);
    setSelectedUsers(users);
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  function formatTime(minutes) {
    if (!minutes || minutes === 0) return "0h:0m";
    const hours = Math.floor(minutes / 60);
    const mins = Math.floor(minutes % 60);
    return `${hours}h:${mins}m`;
  }

  const GetUsers = () => {
    let count;
    let userOnline = 0;
    attendants.forEach((user) => {
      if (user.online === true) {
        userOnline = userOnline + 1;
      }
    });
    count = userOnline === 0 ? 0 : userOnline;
    return count;
  };

  const GetContacts = (all) => {
    let props = {};
    if (all) {
      props = {};
    } else {
      props = {
        dateStart: dateStartTicket,
        dateEnd: dateEndTicket,
      };
    }
    const { count } = useContacts(props);
    return count;
  };

  const GetMessages = (all, fromMe) => {
    let props = {};
    if (all) {
      if (fromMe) {
        props = {
          fromMe: true,
        };
      } else {
        props = {
          fromMe: false,
        };
      }
    } else {
      if (fromMe) {
        props = {
          fromMe: true,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      } else {
        props = {
          fromMe: false,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      }
    }
    const { count } = useMessages(props);
    return count;
  };

  function toggleShowFilter() {
    setShowFilter(!showFilter);
  }

  return (
    <>
      {user.profile === "user" && user.showDashboard === "disabled" ? (
        <ForbiddenPage />
      ) : (
        <MainContainer style={{ padding: 0 }}>
          <div style={{ padding: "10px", height: "100%", boxSizing: "border-box", display: "flex", flexDirection: "column" }}>
            <Paper
              className={classes.mainPaper}
              variant="outlined"
            >
              <div className={classes.dashboardPageWrapper}>
              {/* TÍTULO SEPARADO */}
              <Typography className={classes.headerTitle}>{i18n.t("dashboard.title")}</Typography>
              
              {/* CAIXA COM FILTROS EM 2 LINHAS */}
              <Box className={classes.modernHeader}>
                <Box className={classes.headerFilters}>
                  <Box className={classes.filterWrapper} style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <Typography className={classes.filterLabel}>{i18n.t("dashboard.filterLabels.period")}</Typography>
                    <Box style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap", width: "100%" }}>
                      {[7, 15, 30, 90, 365].map(option => (
                        <Button
                          key={option}
                          size="small"
                          variant={period === option ? "contained" : "outlined"}
                          color="primary"
                          onClick={() => {
                            setPeriod(option);
                            setDateStartTicket(moment().tz(companyTimezone).subtract(option, 'days').format("YYYY-MM-DD"));
                            setDateEndTicket(getCompanyToday(companyTimezone));
                          }}
                          style={{ flex: 1, minWidth: 70, textTransform: 'none', whiteSpace: 'nowrap' }}
                        >
                          {i18n.t("dashboard.filterLabels.days", { count: option })}
                        </Button>
                      ))}
                    </Box>
                  </Box>
                  <Box className={classes.filterWrapper} style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <Typography className={classes.filterLabel}>{i18n.t("dashboard.filterLabels.dateRange")}</Typography>
                    <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <TextField
                        type="date"
                        label={i18n.t("dashboard.date.initialDate")}
                        value={dateStartTicket}
                        onChange={(e) => {
                          setPeriod(0);
                          setDateStartTicket(e.target.value);
                        }}
                        InputLabelProps={{ shrink: true }}
                        size="small"
                        variant="outlined"
                        style={{ flex: 1 }}
                      />
                      <TextField
                        type="date"
                        label={i18n.t("dashboard.date.finalDate")}
                        value={dateEndTicket}
                        onChange={(e) => {
                          setPeriod(0);
                          setDateEndTicket(e.target.value);
                        }}
                        InputLabelProps={{ shrink: true }}
                        size="small"
                        variant="outlined"
                        style={{ flex: 1 }}
                      />
                    </Box>
                  </Box>
                  <Box className={classes.filterWrapper}>
                    <Typography className={classes.filterLabel}>{i18n.t("dashboard.filterLabels.queues")}</Typography>
                    <QueueFilter onFiltered={setSelectedQueuesFilter} />
                  </Box>
                  <Box className={classes.filterWrapper}>
                    <Typography className={classes.filterLabel}>{i18n.t("dashboard.filterLabels.attendants")}</Typography>
                    <UsersFilter onFiltered={setSelectedUsersFilter} />
                  </Box>
                  <Box className={classes.filterWrapper}>
                    <Typography className={classes.filterLabel}>{i18n.t("dashboard.filterLabels.connections")}</Typography>
                    <ConnectionsFilter onFiltered={setSelectedConnectionsFilter} />
                  </Box>
                  <Box className={classes.filterWrapper}>
                    <Typography className={classes.filterLabel}>{i18n.t("dashboard.filterLabels.channels")}</Typography>
                    <WhatsappsFilter onFiltered={setSelectedChannelsFilter} />
                  </Box>
                </Box>
                <Box className={classes.headerActions}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<RefreshIcon />}
                    onClick={() => {
                      setFetchDataFilter(!fetchDataFilter);
                      fetchData();
                    }}
                    style={{ textTransform: 'uppercase', fontWeight: 600, minWidth: 140 }}
                  >
                    {i18n.t("dashboard.filter")}
                  </Button>
                </Box>
              </Box>

              <Grid2 container spacing={3} className={classes.container}>
                {/* Indicadores de Performance */}
                <Grid2 item xs={12}>
                  <Typography className={classes.modernSectionTitle}>{i18n.t("dashboard.sections.performanceIndicators")}</Typography>
                </Grid2>
                {[
                  { label: i18n.t("dashboard.performance.totalAttendances"), value: counters.tickets || 0, icon: CheckCircleIcon, color: "#4CAF50" },
                  { label: i18n.t("dashboard.performance.closed"), value: counters.supportFinished || 0, icon: CheckCircleIcon, color: "#FF9800" },
                  { label: i18n.t("dashboard.performance.open"), value: counters.supportHappening || 0, icon: LaptopIcon, color: "#2196F3" },
                  { label: i18n.t("dashboard.performance.pending"), value: counters.supportPending || 0, icon: HourglassEmptyIcon, color: "#9C27B0" },
                  { 
                    label: i18n.t("dashboard.performance.withoutQueue"), 
                    value: counters.ticketsWithoutQueue || 0, 
                    icon: WarningIcon, 
                    color: "#E91E63",
                    detail: {
                      groups: counters.ticketsWithoutQueueGroups || 0,
                      private: counters.ticketsWithoutQueuePrivate || 0
                    }
                  },
                  { 
                    label: i18n.t("dashboard.performance.withoutUser"), 
                    value: counters.ticketsWithoutUser || 0, 
                    icon: WarningIcon, 
                    color: "#E91E63",
                    detail: {
                      groups: counters.ticketsWithoutUserGroups || 0,
                      private: counters.ticketsWithoutUserPrivate || 0
                    }
                  },
                  { label: i18n.t("dashboard.performance.attendants"), value: attendants.length || 0, icon: LaptopIcon, color: "#FFC107" },
                  { label: i18n.t("dashboard.performance.averageServiceTime"), value: formatTime(counters.avgSupportTime || 0), icon: ScheduleIcon, color: "#00BCD4" },
                  { label: i18n.t("dashboard.performance.averageWaitingTime"), value: formatTime(counters.avgWaitTime || 0), icon: ScheduleIcon, color: "#4CAF50" },
                  { label: i18n.t("dashboard.performance.newContacts"), value: counters.leads || 0, icon: PersonAddIcon, color: "#F44336" },
                ].map((indicator, index) => {
                  const IconComponent = indicator.icon;
                  return (
                    <Grid2 item xs={12} sm={6} md={4} lg={3} key={index}>
                      <Paper 
                        className={classes.modernMetricCard}
                        style={{ borderBottomColor: indicator.color }}
                      >
                        <IconComponent 
                          className={classes.metricCardIcon}
                          style={{ color: indicator.color }}
                        />
                        <Box>
                          <Typography className={classes.metricCardValue}>{indicator.value}</Typography>
                          <Typography className={classes.metricCardLabel}>{indicator.label}</Typography>
                          {indicator.detail && (
                            <Box mt={1} style={{ fontSize: '0.75rem', color: theme.palette.text.secondary }}>
                              <Typography variant="caption" display="block">
                                {i18n.t("dashboard.performance.details", { groups: indicator.detail.groups, private: indicator.detail.private })}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Paper>
                    </Grid2>
                  );
                })}

                {/* Pesquisa de Satisfação (NPS) */}
                <Grid2 item xs={12}>
                  <Typography className={classes.modernSectionTitle}>{i18n.t("dashboard.sections.satisfactionSurvey")}</Typography>
                </Grid2>
                {[
                  { key: "score", label: i18n.t("dashboard.assessments.score"), value: counters.npsScore || 0, color: "#000000" },
                  { key: "promoters", label: i18n.t("dashboard.assessments.prosecutors"), value: counters.npsPromotersPerc || 0, color: "#2EA85A" },
                  { key: "neutral", label: i18n.t("dashboard.assessments.neutral"), value: counters.npsPassivePerc || 0, color: "#F7EC2C" },
                  { key: "detractors", label: i18n.t("dashboard.assessments.detractors"), value: counters.npsDetractorsPerc || 0, color: "#F73A2C" },
                ].map((item, index) => {
                  const { label, value, color } = item;
                  
                  return (
                    <Grid2 item xs={12} md={6} lg={3} key={index}>
                      <Paper className={classes.modernNpsCard}>
                        <Box className={classes.modernProgressContainer}>
                          <Typography className={classes.modernProgressLabel}>{label}</Typography>
                          <LinearProgress
                            variant="determinate"
                            value={value}
                            className={classes.modernProgress}
                            sx={{
                              backgroundColor: "#e0e0e0",
                              "& .MuiLinearProgress-bar": {
                                backgroundColor: color,
                              },
                            }}
                          />
                          <Typography className={classes.modernProgressValue}>{value}%</Typography>
                        </Box>
                      </Paper>
                    </Grid2>
                  );
                })}

                <Can
                  role={user.profile}
                  perform="heatmap:view"
                  yes={() => (
                    <>
                      <Grid2 item xs={12}>
                        <Typography className={classes.modernSectionTitle}>{i18n.t("dashboard.sections.hourlyDistribution")}</Typography>
                      </Grid2>
                      <Grid2 item xs={12}>
                        <AttendanceHeatmap
                          data={heatmapData}
                          details={heatmapDetails}
                          maxCount={heatmapMaxCount}
                          loading={heatmapLoading}
                        />
                      </Grid2>
                    </>
                  )}
                />

                {/* Informações de Atendimento */}
                <Grid2 item xs={12}>
                  <Typography className={classes.modernSectionTitle}>{i18n.t("dashboard.sections.attendances")}</Typography>
                </Grid2>
                {[
                  { label: i18n.t("dashboard.assessments.totalCalls"), value: counters.tickets || 0, icon: <CallIcon style={{ color: '#01BBAC', fontSize: '2rem' }} /> },
                  { label: i18n.t("dashboard.assessments.callsWaitRating"), value: counters.waitRating || 0, icon: <HourglassEmptyIcon style={{ color: '#47606e', fontSize: '2rem' }} /> },
                  { label: i18n.t("dashboard.assessments.callsWithoutRating"), value: counters.withoutRating || 0, icon: <ErrorOutlineIcon style={{ color: '#8a2c40', fontSize: '2rem' }} /> },
                  { label: i18n.t("dashboard.assessments.ratedCalls"), value: counters.withRating || 0, icon: <CheckCircleOutlineIcon style={{ color: '#805753', fontSize: '2rem' }} /> },
                ].map((attInfo, index) => (
                  <Grid2 item xs={12} sm={6} md={3} key={index}>
                    <Paper className={classes.modernAttendanceCard}>
                      {attInfo.icon}
                      <Box>
                        <Typography variant="h5" style={{ fontWeight: 700, marginBottom: theme.spacing(0.5) }}>{attInfo.value}</Typography>
                        <Typography variant="body2" style={{ color: theme.palette.text.secondary }}>{attInfo.label}</Typography>
                      </Box>
                    </Paper>
                  </Grid2>
                ))}

                {/* Índice de Avaliação */}
                <Grid2 item xs={12}>
                  <Typography className={classes.modernSectionTitle}>{i18n.t("dashboard.assessments.evaluationIndex")}</Typography>
                  <Grid2 container alignItems="center" spacing={2}>
                    <Grid2 item xs={12} sm={2}>
                      <Paper className={classes.infoCard} style={{ textAlign: 'center', padding: theme.spacing(1.5, 2), backgroundColor: '#FFE3B3', borderRadius: 10 }}>
                        <Typography variant="h6" style={{ color: '#F79009', fontWeight: 700 }}>
                          {Number(counters.percRating / 100).toLocaleString(undefined, { style: 'percent' }) || "0%"}
                        </Typography>
                      </Paper>
                    </Grid2>
                    <Grid2 item xs={12} sm={10}>
                      <LinearProgress
                        variant="determinate"
                        value={counters.percRating || 0}
                        className={classes.modernProgress}
                        sx={{
                          backgroundColor: "#e0e0e0",
                          height: 12,
                          borderRadius: 6,
                          "& .MuiLinearProgress-bar": {
                            backgroundColor: "#F79009",
                          },
                        }}
                      />
                    </Grid2>
                  </Grid2>
                </Grid2>

                {/* Tabela de Atendentes */}
                <Grid2 item xs={12}>
                  <Typography className={classes.modernSectionTitle}>{i18n.t("dashboard.sections.attendants")}</Typography>
                  <Paper className={classes.paper} style={{ borderRadius: 12, boxShadow: theme.shadows[3] }}>
                    <TableAttendantsStatus
                      attendants={attendants}
                      loading={loading}
                    />
                  </Paper>
                </Grid2>

                {/* Gráficos */}
                <Grid2 container spacing={3} item xs={12}>
                  <Grid2 item xs={12} md={6}>
                    <Paper className={classes.modernChartCard}>
                      <ChatsUser
                        initialDate={dateStartTicket ? new Date(dateStartTicket + "T12:00:00") : new Date()}
                        finalDate={dateEndTicket ? new Date(dateEndTicket + "T12:00:00") : new Date()}
                      />
                    </Paper>
                  </Grid2>
                  <Grid2 item xs={12} md={6}>
                    <Paper className={classes.modernChartCard}>
                      <ChartsDate
                        initialDate={dateStartTicket ? new Date(dateStartTicket + "T12:00:00") : new Date()}
                        finalDate={dateEndTicket ? new Date(dateEndTicket + "T12:00:00") : new Date()}
                      />
                    </Paper>
                  </Grid2>
                </Grid2>
              </Grid2>
              </div>
            </Paper>
          </div>
        </MainContainer>
      )}
    </>
  );
};

export default Dashboard;
